/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PersonRet } from './PersonRet';
import {
    PersonRetFromJSON,
    PersonRetFromJSONTyped,
    PersonRetToJSON,
} from './PersonRet';

/**
 * 
 * @export
 * @interface GetOrganizationsTeam200ResponseAllOf
 */
export interface GetOrganizationsTeam200ResponseAllOf {
    /**
     * 
     * @type {Array<PersonRet>}
     * @memberof GetOrganizationsTeam200ResponseAllOf
     */
    result: Array<PersonRet>;
}

/**
 * Check if a given object implements the GetOrganizationsTeam200ResponseAllOf interface.
 */
export function instanceOfGetOrganizationsTeam200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetOrganizationsTeam200ResponseAllOfFromJSON(json: any): GetOrganizationsTeam200ResponseAllOf {
    return GetOrganizationsTeam200ResponseAllOfFromJSONTyped(json, false);
}

export function GetOrganizationsTeam200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationsTeam200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(PersonRetFromJSON)),
    };
}

export function GetOrganizationsTeam200ResponseAllOfToJSON(value?: GetOrganizationsTeam200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(PersonRetToJSON)),
    };
}

